/// <reference path="../app/app.definition.ts" />

// Webpack's compatibility check

export const IE11 = "isIE11";

if (typeof window !== 'undefined' && window.navigator) {
    if (window.navigator.userAgent.indexOf('Trident/7.0') > 0) {
        $('html').addClass('ie11');
        window[IE11] = true;
    } else {
        window[IE11] = false;
    }
}

// Document wide properties

$(document).on('hidden.bs.popover', function (e) {
    $(e.target).data("bs.popover").inState.click = false;
});

$(document).on("click", function (event) {
    let teamMugshot = null;
    let isPushNotification = false;
    let parentNode = $(event.target).parents('.mugshot-parent');
    if (!!parentNode && parentNode.length > 0) {
        teamMugshot = parentNode[0].getAttribute("name");
    }
    if (event.target.parentElement) {
        if ((event.target.parentElement.id as string).includes('push-notification')) {
            isPushNotification = true;
        }

    }

    const hasPopover = $(event.target).attr("class");
    if (hasPopover || teamMugshot) {
        if (!!hasPopover && hasPopover.includes('red-badge') == true ||
            !!hasPopover && hasPopover.includes('teampopover') == true ||
            !!hasPopover && hasPopover.includes('team-action') == true ||
            !!hasPopover && hasPopover.includes('push-notification') == true ||
            !!hasPopover && hasPopover.includes('filter-action') == true ||
            !!teamMugshot && teamMugshot == 'teamMugshot') {

        } else {
            $('.popover').popover('hide');
        }
    }

    if (isPushNotification) {
        $('.popover').popover('hide');
    }
});
